import { ApiClient } from "client/base";
const TYPE_PREFIX_MAP = {
    COMMENT: "comments",
    PROJECT_ASSUMPTION: "project_assumptions",
    PROJECT_SCENARIO: "project_scenarios",
    PROJECT_SEGMENT_ASSUMPTION: "project_segment_assumptions",
    PROJECT_TASK: "project_tasks",
    TRAINING_DATA: "data",
    REPORT: "reports",
    REPORT_CHART: "report_charts",
    LANGUAGE_MODEL_ARTIFACT: "language_model_artifacts",
    CHAT_TONE: "chat_tones",
    CONTENT_GENERATION_COLLECTION: "content_generation_collections",
    CONTENT_GENERATION_EXECUTION: "content_generation_executions",
    CONTENT_GENERATION_RESULT: "content_generation_results"
};
export class RatingClient extends ApiClient {
    getRating(ratingId) {
        return this.base.get(`ratings/${ratingId}`);
    }
    getRatings(type, id) {
        return this.base.get(`${TYPE_PREFIX_MAP[type]}/${id}/ratings`);
    }
    addRating(type, id, update) {
        return this.base.post(`${TYPE_PREFIX_MAP[type]}/${id}/ratings`, update);
    }
    updateRating(ratingId, update) {
        return this.base.patch(`ratings/${ratingId}`, update);
    }
    deleteRating(ratingId) {
        return this.base.delete(`ratings/${ratingId}`);
    }
}
